import React from 'react'
import PropTypes from 'prop-types'

function UserGalleryItem({ text }) {
  return (
    <div className="user-empty-message">
      <p className="heading-18">{text}</p>
    </div>
  )
}

UserGalleryItem.propTypes = {
  text: PropTypes.string.isRequired,
}

export default UserGalleryItem
